import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {MUTATION_KEYS} from '@/queryClient'
import {buildFile, downloadFile} from '@/utilities/helpers'
import {httpExportPriTxtByMonth} from '@/features/accesses/activity-report/http/priTxtExport.http'
import {parsePriTxtExportFilename} from '@/features/accesses/activity-report/utils'
import {PriTxtExportError, PriTxtExportRequest} from '@/features/accesses/activity-report/types'

// Generates the DSP Flux archive for a month/year and streams the ZIP download.
// The filename comes from the Content-Disposition header, with a client-derived fallback.
export const useExportPriTxtByMonth = (
    options?: Omit<
        UseMutationOptions<void, AxiosError<PriTxtExportError>, PriTxtExportRequest>,
        'mutationKey' | 'mutationFn'
    >
) =>
    useMutation({
        ...options,
        mutationKey: [MUTATION_KEYS.EXPORT_PRI_TXT_BY_MONTH],
        mutationFn: async payload => {
            const response = await httpExportPriTxtByMonth(payload)
            const headerName = parsePriTxtExportFilename(response.headers['content-disposition'])
            const fallbackName = `dsp-flux-${String(payload.month).padStart(2, '0')}-${payload.year}`
            // buildFile appends the extension, so strip a trailing `.zip` from a header-provided name.
            const baseName = (headerName ?? fallbackName).replace(/\.zip$/i, '')
            downloadFile(buildFile({extension: 'zip', fileName: baseName, data: response.data}))
        }
    })
